import { Container, Typography,  Grid } from "@mui/material";
import EmailIcon from "@mui/icons-material/Email";
import FaxIcon from "@mui/icons-material/Fax";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import PhoneIcon from "@mui/icons-material/Phone";
import React from "react";

export default function ContactCard() {
  return (
    <Grid
      container
      justifyContent={"center"}
      rowSpacing={1}
      columnSpacing={{ xs: 1, sm: 2, md: 3 }}
    >
      <Grid item xs={12} sm={6}>
        <Container sx={{ display: "flex", alignItems: "center" }}>
          <EmailIcon />
          <Typography variant="subtitle1">
            Email: Ed@edwardrusselllaw.com
          </Typography>
        </Container>
      </Grid>
      <Grid item xs={12} sm={6}>
        <Container sx={{ display: "flex", alignItems: "center" }}>
          <PhoneIcon />
          <Typography>Phone: (469) 490-0539</Typography>
        </Container>
      </Grid>
      <Grid item xs={12} sm={6}>
        <Container sx={{ display: "flex", alignItems: "center" }}>
          <LocationOnIcon />
          <Typography>
            Address: 539 W. Commerce St, Suite 5539, Dallas, Tx 75208
          </Typography>
        </Container>
      </Grid>
      <Grid item xs={12} sm={6}>
        <Container sx={{ display: "flex", alignItems: "center" }}>
          <FaxIcon />
          <Typography>Fax: (833) 937-1858</Typography>
        </Container>
      </Grid>
    </Grid>
  );
}
